module.exports = "body {\n  background-color: #f3f3f3 !important; }\n\n.common-img-bg {\n  background: #ffffff !important; }\n\n@media (min-width: 759px) and (max-width: 1700px) {\n  .loginlogo {\n    height: 30%;\n    width: 70%; } }\n\n@media (min-width: 1700px) and (max-width: 2400px) {\n  .loginlogo {\n    height: 40%;\n    width: 100%; } }\n\n@media only screen and (max-width: 758px) {\n  .loginlogo {\n    height: 20%;\n    width: 90%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-auth/master-auth.component.scss
// module id = ./src/app/master/master-auth/master-auth.component.scss
// module chunks = main